import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { CircularProgress, MuiThemeProvider, TextField } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import * as actions from 'components/FuelVendor/store/actions';
import {
    FILLED_INPUT_AUTO_COMPLETE_FIELD_THEME,
    SPINNER_THEME
} from 'components/FuelVendor/FuelVendorMuiTheme';
import ClearIcon from '@material-ui/icons/Clear';
import { isBlank, isEmptyList, isNotEmptyObject } from 'components/Common/Utils/StringUtils';
import validateFuelFields from '../Validation/FuelValidation';

const VendorNameSearch = (props) => {
    const {
        isFuelVendorNamesLoaded,
        fuelVendorNames,
        getVendorNames,
        updateFuelAccount,
        isFuelVendorDetailsLoaded,
        selectedFuelVendorId,
        updatedFuelVendorAccount,
        disableInteractField,
        toggleSaveButton,
        isDuplicateFuelVendor,
        toggleEditDetails
    } = props;

    const [open, setOpen] = useState(false);
    const [options, setOptions] = useState([]);
    const [userInput, setUserInput] = useState('');
    const defErrorConfig = {
        isInvalid: false,
        message: ''
    };
    const [field, setFieldValidation] = useState({
        vendor_name: defErrorConfig
    });

    useEffect(() => {
        if (isEmptyList(fuelVendorNames)) {
            getVendorNames();
        }
    }, []);

    useEffect(() => {
        (isFuelVendorDetailsLoaded || isDuplicateFuelVendor) &&
        isNotEmptyObject(updatedFuelVendorAccount)
            ? setUserInput(updatedFuelVendorAccount.vendor_name)
            : setUserInput('');
    }, [isFuelVendorDetailsLoaded]);

    useEffect(() => {
        if (isFuelVendorNamesLoaded) {
            setOptions([
                ...fuelVendorNames.map((fuel) => {
                    return fuel.name;
                })
            ]);
            disableInteractive();
        }
    }, [isFuelVendorNamesLoaded]);

    const disableInteractive = (value) => {
        let isPresent = true;
        fuelVendorNames.map((vendor) => {
            return vendor.types.map((types) => {
                if (types.type === 'Interactive' && vendor.name === value) {
                    isPresent = false;
                }
                return isPresent;
            });
        });
        disableInteractField(isPresent);
    };

    const handleSelectedOption = (event, selectedOption, reason) => {
        let event1 = { target: {} };
        event1.target.name = 'vendor_name';
        event1.target.value = selectedOption;
        if (reason === 'select-option') {
            setUserInput(selectedOption);
            disableInteractive(selectedOption);
            updateFuelAccount({ ...updatedFuelVendorAccount, vendor_name: selectedOption });
            toggleSaveButton(false);
        }
        validateFields(event1);
        toggleEditDetails(true);
    };

    const handleChange = (event) => {
        setUserInput(event.target.value);
        validateFields(event);
        toggleEditDetails(true);
    };

    const validateFields = (event) => {
        const { name, value } = event.target;
        const result = validateFuelFields(event);
        setFieldValidation({ ...field, [name]: result });
        if (isBlank(value)) {
            toggleSaveButton(true);
        }
    };

    return (
        <MuiThemeProvider theme={FILLED_INPUT_AUTO_COMPLETE_FIELD_THEME}>
            <Autocomplete
                id="fuel-vendor-name"
                open={open}
                inputValue={userInput}
                disabled={!isBlank(selectedFuelVendorId)}
                onOpen={() => {
                    setOpen(true);
                }}
                onClose={() => {
                    setOpen(false);
                }}
                getOptionSelected={(option, value) => option === value}
                getOptionLabel={(option) => option}
                options={options}
                loading={!isFuelVendorNamesLoaded}
                loadingText={
                    <MuiThemeProvider theme={SPINNER_THEME}>
                        <CircularProgress />
                    </MuiThemeProvider>
                }
                clearOnBlur={false}
                noOptionsText="(No record found)"
                onChange={(event, selectedOption, reason) =>
                    handleSelectedOption(event, selectedOption, reason)
                }
                onBlur={(event) => validateFields(event)}
                closeIcon={
                    <ClearIcon
                        onClick={() => {
                            setUserInput('');
                        }}
                        fontSize="small"
                    />
                }
                renderInput={(params) => (
                    <TextField
                        required
                        margin="normal"
                        name="vendor_name"
                        {...params}
                        label="Vendor"
                        variant="filled"
                        onChange={(event) => {
                            handleChange(event);
                        }}
                        error={field.vendor_name.invalid}
                        helperText={field.vendor_name.message}
                    />
                )}
            />
        </MuiThemeProvider>
    );
};

const mapStateToProps = (state) => {
    return {
        isFuelVendorNamesLoaded: state.fuelVendor.isFuelVendorNamesLoaded,
        fuelVendorNames: state.fuelVendor.fuelVendorNames,
        isFuelVendorDetailsLoaded: state.fuelVendor.isFuelVendorDetailsLoaded,
        fuelVendorAccount: state.fuelVendor.fuelVendorAccount,
        updatedFuelVendorAccount: state.fuelVendor.updatedFuelVendorAccount,
        isDuplicateFuelVendor: state.fuelVendor.isDuplicateFuelVendor
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getVendorNames: () => dispatch(actions.getVendorNames()),
        updateFuelAccount: (account) => dispatch(actions.updateFuelAccount(account)),
        disableInteractField: (flag) => dispatch(actions.disableInteractField(flag)),
        toggleSaveButton: (flag) => dispatch(actions.toggleSaveButton(flag)),
        toggleEditDetails: (flag) => dispatch(actions.toggleEditDetails(flag))
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(VendorNameSearch));
